export const NAME_SPACE = 'AssetMerge';
export const ROOT_STATE_KEY = 'assetview';
export const ROOT_SLICE_KEY = 'assetMerge';
